import { doc, serverTimestamp, writeBatch } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import type { SeedingMode } from './types';

export interface SeedUpdate {
  participantId: string;
  seed: number | null; // null = убрать seed
}

export async function applySeeding(
  tournamentId: string,
  mode: SeedingMode,
  updates: SeedUpdate[],
  newStatus: 'DRAFT' | 'READY'
): Promise<void> {
  const batch = writeBatch(db);

  for (const u of updates) {
    const ref = doc(db, 'tournaments', tournamentId, 'participants', u.participantId);
    batch.update(ref, { seed: u.seed });
  }

  batch.update(doc(db, 'tournaments', tournamentId), {
    seedingMode: mode,
    status: newStatus,
    updatedAt: serverTimestamp(),
  });

  await batch.commit();
}
